import { styled } from 'linaria/lib/react';

export const StyledSlide = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: stretch;
  width: 100%;
`;
